<template>
	<div class="mt-4">
		<div class="flex items-center">
			<div class="mr-4">
				<template v-if="!(soldOut || isSoldOut) || quantityInBasket > 0">
						<button v-if="quantityInBasket == 0" @click="addToBasket()" class="block p-0 rounded-full outline-none border-top border text-black w-6 h-6 text-lg font-bold bg-white text-center transition-all duration-3s"></button>
						<div v-if="quantityInBasket > 0" class="inline-flex items-center transition-all duration-3s" :class="[loading ? 'opacity-50' : 'opacity-100']">
								<button @click="addQuantity(-1)" class="block p-0 rounded-full outline-none border-gray-300 border text-black w-6 h-6 text-lg font-bold bg-white text-center transition-all duration-3s" :class="[loading ? 'opacity-50 cursor-default' : 'opacity-100 cursor-pointer']">-</button>
								<span class="mx-2 w-10 text-center font-bold text-black">{{ addedQuantityInBasket }}</span>
								<button @click="addQuantity(1)"
										class="block p-0 rounded-full outline-none border-gray-300 border text-black w-6 h-6 text-lg font-bold bg-white text-center transition-all duration-3s"
										:class="[loading ? 'opacity-50 cursor-default' : 'opacity-100 cursor-pointer']">+</button>
						</div>
				</template>
				<div v-else class="block p-0 rounded-full outline-none border-gray-500 border text-black w-6 h-6 text-lg font-bold bg-white text-center transition-all duration-3s"></div>
			</div>
			<div class="mr-auto">
				{{ header }}
			</div>
			<div v-if="soldOut || isSoldOut">
				Udsolgt
			</div>
			<div v-if="!(soldOut || isSoldOut)">
				+ {{ price | toCurrency }}
			</div>
		</div>
		<div>
			<slot></slot>
		</div>
	</div>
</template>
<script>
import debounce from "lodash/debounce";
import store from "./store";
export default {
	data() {
			return {
					toAdd: 0,
					loading: false,
					addToWaitingList: false,
					isSoldOut: false,
			}
	},
	props: {
			header: String,
			price: Number,
			productId: String,
			soldOut: Boolean
	},
    computed: {
        quantityInBasket: function() {
            return this.$store.getters.quantityInBasket(this.productId);
        },
        addedQuantityInBasket: function() {
            return this.quantityInBasket + this.toAdd;
        }
    },
    methods: {
        addToBasket: function(add) {
            this.$store.dispatch("addToBasket", {
                productId: this.productId
            }).then(response => {}).catch(response => {
                if (response.noSuccess) {
                    this.$store.dispatch("updateBasket").then(response => {
                        setTimeout(() => {
                        if (this.quantityInBasket == 0) {
                            alert(response.message)
                            this.isSoldOut = true;
                        }
                        }, 100);
                    })
                }
						});
        },
        addQuantity: function(add) {
            if (!this.loading)
            {
                this.toAdd = this.toAdd + add;
                this.updateBasketCount(this.toAdd);
            }
        },
        updateBasketCount: debounce(function () {
            this.loading = true;
            this.$store.dispatch("updateBasketQuantity", {
                productId: this.productId,
                quantity: this.quantityInBasket + this.toAdd
            }).then(() => {
                this.toAdd = 0;
                this.loading = false;
            })
        }, 500)
    }
}
</script>
